import store from '@/store';
export function getTokenNode() {
    if(store && store.state){
        return store.state.auth.accessToken   
    }else{
        return ''
    }
}












